import { enhancedApi } from '@store/generated/jotbill-analytics';

export const revenueApi = enhancedApi.enhanceEndpoints({
  endpoints: {
    getV2ProviderBillingRevenueContainer: { keepUnusedDataFor: 0 },
    getV2ProviderBillingRevenueComponentsCleanClaims: { keepUnusedDataFor: 0 },
    getV2ProviderBillingRevenueComponentsArAging: { keepUnusedDataFor: 0 },
  },
});
export const useRevenueContainerQuery =
  revenueApi.endpoints.getV2ProviderBillingRevenueContainer.useQuery;
export const useCleanClaimsQuery =
  revenueApi.endpoints.getV2ProviderBillingRevenueComponentsCleanClaims.useQuery;
export const useArAgingQuery =
  revenueApi.endpoints.getV2ProviderBillingRevenueComponentsArAging.useQuery;
export type {
  ArAgingPayload,
  CleanClaimsPayload,
  RevenueAgeCell,
  RevenueClaimPage,
  RevenueClaimRow,
  GetV2ProviderBillingRevenueComponentsCleanClaimsApiArg as RevenueFilters,
} from '@store/generated/jotbill-analytics';
